import React from 'react'
import { Link } from 'react-router-dom';
import { Button, Container, Icon, Segment } from 'semantic-ui-react';
const TitleBar = (props) => {
    return (
        <div id="dispatch_bar">
            <Container fluid className="m-0 p-0">
                <div className="p-2 mb-0">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="d-flex justify-content-between">
                                <label className="page-title">{props.title}</label>
                                <div className="form-inline">
                                    {props.children}
                                    <Button hidden={props.hiddenNew} as={Link} to={props.LinkName ? props.LinkName : '#'} size="mini" className="w3-text-white" primary  icon><Icon name="plus" className="w3-text-white" /> New</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Container>
        </div>
    )
}

export default TitleBar
